<template>
	<Form ref="formValidate" :model="formValidate"  :label-width="110":label-colon="true">
		<Row>
			
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="用户ID" :label-width="80">
				<Input v-model="formValidate.userId" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="会员类型">
				<Select v-model="formValidate.type" clearable>
					<Option value="1">普通会员</Option>
					<Option value="2">基础会员</Option>
					<Option value="3">pro会员</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="10" :sm="12" :xs="24">
			<FormItem>
				<Button type="primary" @click="formSubmit" icon="md-search"style="margin: 0 8px 16px 16px;">查询</Button>
				<Button type="default" @click="formReset" style="margin: 0 8px 16px 16px;">重置</Button>
			</FormItem>
			</Col>
		</Row>
	</Form>
</template>
<script>
	import api from '../../api'
	import { mapGetters } from 'vuex'
	import { STATISTICS_START_TIME, LINK_TYPES, ADVERT_TYPES } from '../../config/constants'

	export default {
		name: 'QueryCondition',
		props: {

		},
		data() {
			return {
				
				formValidate: {
					type:undefined,
					userId:undefined,
				},
				dateRangeOptions: {
					//当前日期之后日期为禁选日期
					disabledDate(date) {
						const startDate = new Date(STATISTICS_START_TIME).getTime()
						const now = Date.now()
						return (
							date && !(date.valueOf() >= startDate && date.valueOf() <= now)
						)
					}
				}
			}
		},

		methods: {
			
			formSubmit() {
				this.$emit('query', this.getFormData())
			},
			
			formReset() {
				this.$refs['formValidate'].resetFields()
				this.formValidate = {
					dateRange: [],
				}
				this.formSubmit()
			},
			getFormData() {

				const formData = {
					userId:this.formValidate.userId,
					type:this.formValidate.type
				}
				return formData
			}
		}
	}
</script>
